export default "__VITE_ASSET__dSTXewWc__"